import { loadItem, saveItem, storageKeys } from "../../shared/storage/index";

export const MAX_OWN_REELS = 4;

export const OWN_REELS_UPDATED_EVENT = "greydates:own-reels-updated";

const PLACEHOLDER_POSTERS = [
  "https://picsum.photos/seed/own-reel-1/540/960",
  "https://picsum.photos/seed/own-reel-2/540/960",
  "https://picsum.photos/seed/own-reel-3/540/960",
  "https://picsum.photos/seed/own-reel-4/540/960",
];

function normalizeReel(entry, index) {
  if (!entry || typeof entry !== "object") return null;

  const id = entry.id ? String(entry.id) : `own-reel-${index + 1}`;
  const poster = entry.poster || PLACEHOLDER_POSTERS[index % PLACEHOLDER_POSTERS.length];

  return {
    id,
    mediaType: "video",
    media: entry.media || "",
    poster,
    description: entry.description ? String(entry.description) : "",
    createdAt: entry.createdAt || Date.now(),
  };
}

export function notifyOwnReelsUpdated() {
  window.dispatchEvent(new CustomEvent(OWN_REELS_UPDATED_EVENT));
}

export function loadOwnReels() {
  const stored = loadItem(storageKeys.ownReels, []);
  if (!Array.isArray(stored)) return [];

  return stored
    .map((entry, index) => normalizeReel(entry, index))
    .filter(Boolean)
    .slice(0, MAX_OWN_REELS);
}

function persistOwnReels(reels) {
  const trimmed = reels.slice(0, MAX_OWN_REELS);
  const ok = saveItem(storageKeys.ownReels, trimmed);
  if (ok) {
    notifyOwnReelsUpdated();
  }
  return ok;
}

export function addOwnReel({ media = "", poster = "" } = {}) {
  const reels = loadOwnReels();
  if (reels.length >= MAX_OWN_REELS) {
    return { ok: false, error: `You can upload up to ${MAX_OWN_REELS} reels.` };
  }

  const index = reels.length;
  const nextReel = normalizeReel({
    id: `own-reel-${Date.now()}`,
    media,
    poster: poster || PLACEHOLDER_POSTERS[index % PLACEHOLDER_POSTERS.length],
    createdAt: Date.now(),
  }, index);

  const ok = persistOwnReels([...reels, nextReel]);
  return ok
    ? { ok: true, reel: nextReel, reels: loadOwnReels() }
    : { ok: false, error: "Could not save your reel." };
}

export function deleteOwnReel(reelId) {
  const reels = loadOwnReels().filter((reel) => reel.id !== reelId);
  const ok = persistOwnReels(reels);
  return ok
    ? { ok: true, reels }
    : { ok: false, error: "Could not delete this reel." };
}
